import { render } from "./ManpowerCostByLGReport.vue?vue&type=template&id=7818a650&ts=true&lang=pug"
import script from "./ManpowerCostByLGReport.vue?vue&type=script&lang=ts"
export * from "./ManpowerCostByLGReport.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__